module.exports = __webpack_public_path__ + "static/media/img2-2.dbc2f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/biomasa/img2-2.png
// module id = 1267
// module chunks = 3